import { useEffect, useState } from "react";
import { KeyRound, RefreshCw } from "lucide-react";
import api, { fmtDate } from "@/lib/api";

export const OtpCodes = () => {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/otp/recent").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!data) return null;
  return (
    <div className="bg-[#0A0A0A] border border-white/10 p-8 lg:col-span-2" data-testid="otp-codes-card">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-2">
          <KeyRound size={14} className="text-[#D4AF37]" />
          <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-[#D4AF37]">Registration OTP codes</p>
        </div>
        <div className="flex items-center gap-3">
          <span data-testid="otp-channel-badge" className={`font-accent text-[9px] tracking-[0.15em] uppercase border px-2 py-1 ${data.sms_configured ? "text-emerald-400 border-emerald-400/40" : "text-yellow-400 border-yellow-400/40"}`}>
            {data.sms_configured ? "SMS via Twilio" : "Email fallback"}
          </span>
          <button type="button" data-testid="otp-refresh-button" onClick={load} className="text-white/40 hover:text-[#D4AF37] transition-colors" aria-label="Refresh"><RefreshCw size={14} /></button>
        </div>
      </div>
      <p className="text-xs text-white/50 leading-relaxed mb-5">
        New investors must verify their mobile number with a 6-digit OTP before registering. {data.sms_configured ? "Codes are sent by SMS." : "Add a Twilio SMS sender number above to send real SMS — until then the code is emailed to the investor and listed here so you can help them over the phone."}
      </p>
      <div className="border border-white/10 max-h-72 overflow-y-auto">
        {data.items.map((o, i) => (
          <div key={`${o.phone}-${o.created_at}`} className="grid grid-cols-12 gap-3 px-4 py-3 border-b border-white/10 last:border-0 items-center text-xs" data-testid={`otp-row-${i}`}>
            <span className="col-span-3 font-mono text-white/80">{o.phone}</span>
            <span className="col-span-3 text-white/50 truncate">{o.email || "—"}</span>
            <span className="col-span-2 font-mono tracking-[0.3em] text-[#D4AF37]" data-testid={`otp-code-${i}`}>{o.code}</span>
            <span className="col-span-2 text-white/40">{o.channel} · {o.used ? "used" : o.verified ? "verified" : new Date(o.expires_at) < new Date() ? "expired" : "active"}</span>
            <span className="col-span-2 text-white/40 text-right">{fmtDate(o.created_at).split(",")[1]}</span>
          </div>
        ))}
        {data.items.length === 0 && <p className="px-4 py-6 text-sm text-white/40" data-testid="otp-empty">No OTP requests yet.</p>}
      </div>
    </div>
  );
};
